
//const simplify = require('simplify-js');

export const toPoly = (element) => {
  switch (element.tagName) {
  case 'rect': return rectToPoly(element);
  case 'polygon': return polygonToPoly(element);
  case 'path': return pathToPoly(element);//simplify(pathToPoly(element), 0.5);
  case 'circle': return circleToPoly(element);
  case 'ellipse': return ellipseToPoly(element);
  default: console.warn('Unhandled element', element); return [];
  }
};

export const rectToPoly = element => {
  const {x, y, width, height} = getValues(element, 'x', 'y', 'width', 'height');
  return [
    [x, y], 
    [x+width, y], 
    [x+width, y+height], 
    [x, y+height], 
    [x, y]
  ];
};

/* Returns poly data type by mapping polygon points. */
export const polygonToPoly = element => map(p => [p.x, p.y], element.points);

/* Returns poly by sampling path to points */
export const pathToPoly = element => samplePolygonFromPath(element, 100);

/* */
export const circleToPoly = element => {
  const {cx, cy, r} = getValues(element, 'cx', 'cy', 'r');
  const opp = oppositeSide(r);
  const nxt = nextSide(r);
  return [
    [cx-r, cy],
    [cx-opp(45), cy-nxt(45)],
    [cx, cy-r],
    [cx+opp(45), cy-nxt(45)],
    [cx+r, cy],
    [cx+opp(45), cy+nxt(45)],
    [cx, cy+r],
    [cx-opp(45), cy+nxt(45)]
  ];
};

/**
 * Returns just bounding box of the ellipse. That should be enough our purposes
 * but if more accurate implementation is needed we could go with detour 
 * ellipse -> path -> poly. See following link
 * https://github.com/mailzwj/sstp/blob/master/svg-shape-to-path.js
 */
export const ellipseToPoly = element => {
  
  const {cx, cy, rx, ry} = getValues(element, 'cx', 'cy', 'rx', 'ry');
  const x = cx - rx,
        y = cy - ry,
        width = rx * 2,
        height = ry * 2;
  
  return [
    [x, y], 
    [x+width, y], 
    [x+width, y+height], 
    [x, y+height], 
    [x, y]
  ];
};

/*
  Helper functions
*/
const map = (functor, iterable) => Array.prototype.map.call(iterable, functor);

export const getValues = (element, ...attributes) => 
  attributes.reduce((map, attr) => (map[attr] = element[attr].baseVal.value, map), {});

const round = (val, by) => Math.round(val * by) / by;
const oppositeSide = hyp => ang => round(Math.sin(ang * Math.PI/180) * hyp, 1e+6);
const nextSide = hyp => ang => round(Math.cos(ang * Math.PI/180) * hyp, 1e+6);


export const samplePolygonFromPath = (path, samples) => {
  
  const pathLength = path.getTotalLength();
  const step = pathLength / samples;
  
  const points = Array.from({length: samples}, (_,i) => {
    const {x,y} = path.getPointAtLength(i*step);
    return [x,y];
  });
  return points;
};

